export default __webpack_public_path__ + "static/Blind-angels-kayla-profile-ad0e4c383434650baf0b35085de47792.png";